import { type RouteRecordRaw } from 'vue-router';

export const authRoute: RouteRecordRaw = {
  path: '/auth',
  name: 'auth',
  meta: {
    guest: true,
    layout: 'blank',
  },
  component: () => import('@bv/layouts/auth/AuthLayout.vue'),
  redirect: { name: 'auth-login' },
  children: [
    {
      path: 'login',
      children: [
        {
          path: '',
          name: 'auth-login',
          component: () => import('@bv/layouts/auth/views/AuthLogin.vue'),
        },
        {
          path: 'otp',
          name: 'auth-login-otp',
          component: () => import('@bv/layouts/auth/views/LoginOtpCode.vue'),
        },
      ],
    },
    {
      path: 'forget-password',
      children: [
        {
          path: '',
          name: 'auth-forgot-password',
          component: () => import('@bv/layouts/auth/views/LoginForgetPassword.vue'),
        },
        {
          path: 'otp',
          name: 'auth-forgot-password-otp',
          component: () => import('@bv/layouts/auth/views/ResetPassOtp.vue'),
        },
        {
          path: 'reset',
          name: 'auth-forgot-password-reset',
          component: () => import('@bv/layouts/auth/views/LoginResetPassword.vue'),
        },
      ],
    },
    {
      path: 'invitation',
      name: 'auth-invitation',
      component: () => import('@bv/layouts/auth/views/LoginViaInvitation.vue'),
    },
  ],
};
